import { Box, Typography, useTheme } from "@mui/material";
import { AppointmentCardProps } from "../types/AppointmentCard.types";
import CardWrapper from "../../../common/cards/CardWrapper/CardWrapper";
import AppointmentCardHeader from "ui/appointment/components/common/cards/AppointmentCardHeader/AppointmentCardHeader";
import AppointmentCardBody from "ui/appointment/components/common/cards/AppointmentCardBody/AppointmentCardBody";
import AppointmentCardFooterSingleBtn from "ui/appointment/components/appointmentList/cardButtons/AppointmentCardFooterSingleBtn/AppointmentCardFooterSingleBtn";
import ShowMoreLessPanel from "lib/components/notice/ShowMoreLessPanel/ShowMoreLessPanel";
import mapRawStringToReactElement from "lib/util/ReactComponentUtil/mapRawStringToReactElement/MapRawStringtoReactElement";
import { sxStyles } from "../UpcomingAppointmentCard/UpcomingAppointmentCard.styles";
import { useAppSelector } from "lib/redux/hooks";
import { selectAppointments } from "ui/appointment/ducks/selectors";

const MissedAppointmentCard = ({
  appointment,
  isLiveChatEnabled,
}: AppointmentCardProps) => {
  const theme = useTheme();
  const classes = sxStyles(theme);

  // Redux States
  const teleconsultMessage =
    useAppSelector(selectAppointments).teleconsultMessage;

  const {
    datetime,
    institutionName,
    clinician,
    departmentName,
    location,
    zoneInfo,
    serviceDisplayName,
    visitType,
    reminder,
    formFlowDisclaimer,
    actionMessage,
    sourceSystem,
    hasTeleconsultmessage,
    isVirtualConsultAppointment,
  } = appointment;

  return (
    <CardWrapper isLinkedAppointmentStyled={false}>
      <Box display="flex">
        <AppointmentCardHeader datetime={datetime} />
        <AppointmentCardBody
          institution={institutionName}
          datetime={datetime}
          departmentName={departmentName}
          clinician={clinician}
          location={location}
          zoneInfo={zoneInfo}
          serviceDisplayName={serviceDisplayName}
          visitType={visitType}
          isVcp={isVirtualConsultAppointment === true ? true : false}
        />
      </Box>

      {hasTeleconsultmessage && (
        <Box p={1}>
          <ShowMoreLessPanel message={teleconsultMessage} />
        </Box>
      )}

      {reminder && (
        <Box p={1} sx={classes.reminderText}>
          <ShowMoreLessPanel message={reminder} />
        </Box>
      )}

      {
        // !exp formFlowDisclaimer value is created by lambda
        formFlowDisclaimer && (
          <Typography sx={classes.shouldSubmitRequestDisclaimerText}>
            {mapRawStringToReactElement(formFlowDisclaimer)}
          </Typography>
        )
      }

      {sourceSystem === "NGEMR" && actionMessage && (
        <Typography sx={classes.actionMsg}>
          {mapRawStringToReactElement(actionMessage)}
        </Typography>
      )}

      <AppointmentCardFooterSingleBtn
        appointment={appointment}
        btnText="Re-book appointment"
        isLiveChatEnabled={isLiveChatEnabled}
      />
    </CardWrapper>
  );
};

export default MissedAppointmentCard;
